import React from 'react'
import PropTypes from 'prop-types'
import TrackableSection, { Trackable } from '../tracking'
import snakeCaseKeys from 'snakecase-keys'

class VideoTracker extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      videoWatchedTillEnd: false
    }

    this.handleEnded = this.handleEnded.bind(this)
    this.handleWindowClosed = this.handleWindowClosed.bind(this)
    this.handleOnPause = this.handleOnPause.bind(this)
  }

  /**
   * Makes a POST request to the server to track video
   * view information
   * @param {String} eventName
   */
  createVideoTrack(eventKey, eventName) {
    const { updateToTrack } = this.trackingContext
    updateToTrack(eventKey, {
      event: eventName,
      addToAccessed: true,
      currentTime: this.props.videoPlayer.currentTime()
    })
  }

  handleEnded() {
    this.setState({ videoWatchedTillEnd: true })
    this.createVideoTrack('ended', 'Ended')
    this.trackingContext.trackManually()
  }

  handleWindowClosed() {
    if (this.props.videoHasBeenPlayed && !this.state.videoWatchedTillEnd) {
      this.createVideoTrack('windowClosed', 'Window Closed')
    }
  }

  handleOnPause() {
    const updateToTrack = this.trackingContext.updateToTrack

    const player = this.props.videoPlayer
    const params = {
      event: 'pause',
      currentTime: player.currentTime()
    }
    updateToTrack('pause', params)
  }

  componentDidUpdate() {
    if (this.props.videoPlayer) {
      this.unbindTrackingEvents()
      this.bindTrackingEvents()
    }
  }

  componentWillUnmount() {
    if (this.props.videoPlayer) {
      this.unbindTrackingEvents()
    }
  }

  bindTrackingEvents() {
    const player = this.props.videoPlayer

    player.on('pause', this.handleOnPause)
    player.on('ended', this.handleEnded)
  }

  unbindTrackingEvents() {
    const player = this.props.videoPlayer

    player.off('pause', this.handleOnPause)
    player.off('ended', this.handleEnded)
  }

  render() {
    return (
      <TrackableSection
        defaultUrl='/video_tracks'
        urlPrefix='/api/v2'
        onBeforeUnload={this.handleWindowClosed}
        globalParams={snakeCaseKeys(this.props.videoInfo)}
        disabledEvents={['pause']} // This is temporary until we decide to start logging
      >
        <Trackable>
          {(context) => {
            if (!this.eventsBinded && this.props.videoPlayer) {
              if (!this.trackingContext) {
                this.trackingContext = context
              }

              this.eventsBinded = true
              this.bindTrackingEvents()
            }

            return this.props.children
          }}
        </Trackable>
      </TrackableSection>
    )
  }
}

VideoTracker.propTypes = {
  children: PropTypes.node,
  videoInfo: PropTypes.object,
  videoPlayer: PropTypes.object,
  videoHasBeenPlayed: PropTypes.bool
}

export default VideoTracker
